import type { Column } from '@/components/Organisms/DataTable/DataTable.types';
import { createdOnDateRanges } from '@/constants';

export const unmatchedInvoicesToClaimsColumns: Column[]= [
    {
        key: 'Clinic',
        label: 'Clinic',
        type: 'string',
        width: '300px',
        sorter: true,
    },
    {
        key: 'productid1',
        label: 'Tissue ID',
        type: 'string',
        width: '150px',
        sorter: true,
    },
    {
        key: 'PhysicianName',
        label: 'Provider',
        width: '150px',
        type: 'string',
        sorter: true,
    },
    {
        key: 'EMRID',
        label: 'EMR ID',
        width: '130px',
        type: 'string',
        sorter: true,
    },
    {
        key: 'patient',
        label: 'Patient Name',
        width: '150px',
        type: 'string',
        sorter: true,
    },
    {
        key: 'ProcedureDOS',
        label: 'Procedure DOS',
        width: '120px',
        type: 'date',
        customDateRanges: createdOnDateRanges,
        sorter: true,
    },
    {
        key: 'product',
        label: 'Product',
        type: 'string',
        width: '150px',
        sorter: true,
    },
    {
        key: 'QCode',
        label: 'HCPCS',
        width: '80px',
        type: 'string',
        sorter: true,
    },
    {
        key: 'SumOfUnits',
        label: 'Total Units',
        type: 'number',
        sorter: true,
    },
    {
        key: 'claimdisposition',
        label: 'Claims Disposition',
        width: '200px',
        type: 'string',
        sorter: true,
    },
    {
        key: 'primaryinsurance',
        label: 'Primary Insurance',
        width: '280px',
        type: 'string',
        sorter: true,
    }
];
export const unmatchedClaimsToInvoicesColumns: Column[]= [
    {
        key: 'clinicName',
        label: 'Clinic',
        type: 'string',
        width: '350px',
        sorter: true,
    },
    {
        key: 'patientName',
        label: 'Patient',
        type: 'string',
        width: '150px',
        sorter: true,
    },
    {
        key: 'total_charges',
        label: 'Total Charges',
        type: 'number',
        sorter: true,
    },
    {
        key: 'total_pmts',
        label: 'Total payments',
        type: 'number',
        sorter: true,
    },
    {
        key: 'postdate',
        label: 'Post Date',
        type: 'date',
        customDateRanges: createdOnDateRanges,
        sorter: true,
    }
];

export const missBilledUnitsColumns: Column[]= [
    {
        key: 'clinic',
        label: 'Clinic',
        type: 'string',
        width: '220px',
        sorter: true,
    },
    {
        key: 'PhysicianName',
        label: 'Provider',
        type: 'string',
        width: '150px',
        sorter: true,
    },
    {
        key: 'patientName',
        label: 'Patient',
        type: 'string',
        width: '150px',
        sorter: true,
    },
    {
        key: 'qcode',
        label: 'HCPCS',
        type: 'string',
        width: '80px',
        sorter: true,
    },
    {
        key: 'Product',
        label: 'Product',
        type: 'string',
        width: '200px',
        sorter: true,
    },
    {
        key: 'units',
        label: 'Invoice Units',
        type: 'number',
        width: '100px',
        sorter: true,
    },
    {
        key: 'sumofunits',
        label: 'Claims Units',
        type: 'number',
        width: '100px',
        sorter: true,
    },
    {
        key: 'emrid',
        label: 'EMR ID',
        type: 'string',
        sorter: true,
    },
    {
        key: 'proceduredos',
        label: 'Procedure DOS',
        width: '120px',
        type: 'date',
        customDateRanges: createdOnDateRanges,
        sorter: true,
    },
    {
        key: 'tatransactionid',
        label: 'Transaction ID',
        type: 'string',
        sorter: true,
    }
];

export const missBilledUnitsHCPCSColumns: Column[]= [
    {
        key: 'Product',
        label: 'Product',
        type: 'string',
        width: '150px',
        sorter: true,
    },
    {
        key: 'emrid',
        label: 'EMR ID',
        type: 'string',
        sorter: true,
    },
    {
        key: 'PatientLastName', // ! where is the full name?
        label: 'Patient Name',
        type: 'string',
        sorter: true,
    },
    {
        key: 'clinic',
        label: 'Clinic',
        type: 'string',
        sorter: true,
    },
    {
        key: 'PhysicianName',
        label: 'Provider',
        type: 'string',
        sorter: true,
    },
    {
        key: 'BillingQCode',
        label: 'Claim HCPCS',
        type: 'string',
        width: '80px',
        sorter: true,
    },
    {
        key: 'qcode',
        label: 'HCPCS',
        type: 'string',
        width: '80px',
        sorter: true,
    },
    {
        key: 'proceduredos',
        label: 'Procedure DOS',
        width: '120px',
        type: 'date',
        customDateRanges: createdOnDateRanges,
        sorter: true,
    },
    {
        key: 'tatransactionid',
        label: 'Transaction ID',
        type: 'string',
        sorter: true,
    }
];
